// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"c47763d4","686":"90aebb7c","791":"adb9d65b"}[chunkId] + ".chunk.js";
};